import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { AddNewUserService } from "../services/add-new-user.service";
import { User } from "../services/add-new-user.service"
import { MatDialog } from '@angular/material/dialog';
import { EditItemModalComponent } from '../edit-user-dialog/edit-user-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// import { ClrDatagrid, ClrModal } from '@clr/angular';
// import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

// cabinet-user-summary.component.ts

@Component({
  selector: 'app-user-summary',
  templateUrl: './cabinet-user-summary.component.html',
  styleUrls: ['./cabinet-user-summary.component.scss']
})
export class CabinetUserSummaryComponent implements OnInit {
//   @ViewChild('addOrderModal', { static: false }) 
// addOrderModal?: ClrModal;

  
  
  @ViewChild('actionTemplate', { static: true }) actionTemplate: TemplateRef<any>;
  
  // @ViewChild(ConfirmDialogComponent, { static: false })
  // confirmDeleteModal?: ConfirmDialogComponent;
  
  
  selectedUser?: User;

  columns = [];

  rows = [];
  page = { totalElements: 0, pageNumber: 0, size: 10 };
  dataLoading = false;
  exportLoading = false;
  exportDetailsLoading = false;
  features = []; // Define your features if needed

  constructor(private addNewUserService: AddNewUserService, private modalService: NgbModal, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadUsers();
    // setTimeout(() => {
    //   // Modify your data here
    //   this.cdr.detectChanges(); // Manually trigger change detection
    // }, 0);
  }


  ngAfterViewInit(): void {
    // Define columns after view initialization
    this.columns = [
      {
        name: '',
        cellTemplate: this.actionTemplate, // Reference to the action template
        maxWidth: 50 // Optional: limit the width of the action column
      },
      { name: 'Full name', prop: 'full_name' },
      { name: 'Role', prop: 'role' },
      { name: 'Product', prop: 'product_name' },
      { name: 'Takeout Limit', prop: 'takeout_limit' },
      { name: 'Remaining Takeout', prop: 'remaining_takeout' },
      { name: 'Tag ID', prop: 'tag_id' },
      
    ];

    this.cdr.detectChanges();
  }

  loadUsers(): void {
    this.dataLoading = true;
    this.addNewUserService.getUserSummary().subscribe(data => {
      console.log("comp");
      console.log(data.users);
      // this.rows = data.users.map(user => {
      //   const productsInfo = user.products.map(product => ({
      //     full_name: user.full_name,
      //     role: user.role,
      //     tag_id: user.tag_id,
      //     product_name: product.name,
      //     product_number: product.product_number,
      //     takeout_limit: product.pivot.allowed_amount, 
      //     remaining_takeout: product.pivot.remaining_amount, 
      //   }));
      //   return productsInfo;
      // }).flat(); 
      this.rows = [].concat(...data.users.map(user => {
        return user.products.map(product => ({
          user_id: user.cuid,
          full_name: user.full_name,
          role: user.role,
          tag_id: user.tag_id,
          product_name: product.name,
          product_number: product.product_number,
          product_id: product.cuid,
          takeout_limit: product.pivot.allowed_amount,
          remaining_takeout: product.pivot.remaining_amount,
        }));
      }));
      console.log("comp2");
      console.log(this.rows);
      console.log("comp2");
      console.log(this.rows);
      this.dataLoading = false;
    });
  }

  setPage(event: any): void {
    // Handle pagination
    this.page.pageNumber = event.offset;
    this.loadUsers();
  }

  onSort(event: any): void {
    // Handle sorting
    console.log('Sort event:', event);
  }

  onExportDetails(): void {
    // Handle export details
    console.log('Export details');
  }

  onEdit(product: User) {
    this.selectedUser = product;
    console.log(this.selectedUser)
    console.log(product)
    // this.addOrderModal?.open();
    // if (this.addOrderModal) {
    //   this.addOrderModal.open();
    // }
    
  }

  onDelete(product: User) {
    this.selectedUser = product;
    console.log(this.selectedUser)
    console.log(product)
    // if (this.addOrderModal) {
    //   this.confirmDeleteModal.show();
    // }
    
    // this.confirmDeleteModal?.show();
  }

  openEditModal(row) {
    this.cdr.detectChanges();
    // console.log(editContent)
    console.log("row")
    console.log(row)
    const modalRef = this.modalService.open(EditItemModalComponent, { ariaLabelledBy: 'modal-basic-title' });
    console.log(modalRef)
    console.log("componentInstance")
    console.log(modalRef.componentInstance)
    console.log("componentInstance2")
    modalRef.componentInstance.row = row;
    console.log(modalRef.componentInstance)
    this.cdr.detectChanges();
    modalRef.result.then((result) => {
      if (result === 'saved') {
        console.log(modalRef)
        console.log(result)
        console.log("done")
        this.loadUsers()// Handle the delete confirmation here
      }
      // Handle the result here if needed
    }).catch((error) => {
      console.log(modalRef)
      console.log(error)
      console.log("not")
      // Handle the error here if needed
    });
  }

  openDeleteModal(row) {
    console.log(row)
    const text = `Are you sure you want to delete the user "${row.username}"? This action cannot be undone.`;
    const modalRef = this.modalService.open(ConfirmDialogComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.row = row;
    modalRef.componentInstance.message = text;
    modalRef.result.then((result) => {
      if (result === 'saved') {
        console.log(modalRef)
        console.log(result)
        console.log("done")
        this.loadUsers()
        // Handle the delete confirmation here
      }
    }).catch((error) => {
      // Handle the error here if needed
    });
  }
}

